module.exports = __webpack_public_path__ + "static/media/may-lose.f0fe59bc.png";